import styled from "styled-components";
import { breakpoints } from "./size";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

export const TopList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.$needBackGroundColor ? props.theme.sidebar : 'transparent'};

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    align-items: baseline;
    gap: 20px;
    overflow: auto hidden;
  }
`;

export const TabsWrapper = styled(Tabs)``;

export const TabListWrapper = styled(TabList)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  list-style-type: none;
  overflow: auto hidden;
  text-wrap: nowrap;

  &.teamTabs {
    width: 100%;
    overflow: auto hidden;
    scrollbar-width: auto !important;

    @media only screen and (${breakpoints.mobile}) {
      width: 100%;
      overflow: auto hidden;
      scrollbar-width: none !important;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &.competitionTabs {
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
      height: 0;
    }

    @media only screen and (${breakpoints.mobile}) {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }

  @media only screen and (${breakpoints.mobile}) {
    overflow: auto hidden;
    white-space: nowrap;
  }
`;

export const TabTitle = styled(Tab)`
  opacity: 1;
  color: ${(props) => props.theme.blueish};
  font-family: "SpaceGrotesk";
  font-size: 19px;
  font-weight: 700;
  font-style: Bold;
  letter-spacing: 1px;
  text-align: left;
  line-height: 30px;
  text-transform: uppercase;
  outline: none;
  background: transparent;
  cursor: pointer;
  position: relative;

  span {
    background-color: #fa3e3e;
    border-radius: 2px;
    padding: 1px 3px;
    font-size: 10px;
    color: white;
    font-family: "SpaceGrotesk";
    position: absolute;
    top: 0;
    right: -20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    border-radius: 9999px;
    line-height: 1;
  }

  &.react-tabs__tab--selected {
    color: ${(props) => props.theme.green}; !important;
  }
`;

export const TabContent = styled(TabPanel)`
  margin-top: 10px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  span {
    font-family: "SpaceGrotesk";
    color: ${(props) => props.theme.white};
    padding: 0 10px;
    font-size: 16px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 14px;
    }
  }
`;
export const PageButton = styled.button`
  border-radius: 1px;
  border: none;
  opacity: 1;
  background-color: ${(props) => props.theme.green};
  color: ${(props) => props.theme.black};
  opacity: 1;
  font-family: "SpaceGrotesk";
  font-size: 16px;
  font-weight: 700;
  font-style: Bold;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  text-transform: uppercase;
  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 30px;
  cursor: pointer;
  float: right;

  .leftTransform {
    transform: rotate(270deg);
  }

  .rightTransform {
    transform: rotate(90deg);
  }
`;
